import React, { Component, Suspense, lazy } from 'react';
import { connect, useSelector } from 'react-redux';
import { Switch, withRouter } from 'react-router-dom';
import { toggleSidepanel } from '../../actions/sidepanel';
import HashRoute from '../../components/HashRoute';
import Splash from '../../components/Splash';
import ProfileBlock from '../../components/ProfileBlock';
import SSRStorage from '../../services/storage';
import { SIDE_PANEL } from '../../services/constants';

const storage = new SSRStorage();

const NurseObservation = lazy(() => import('../../components/Patient/NurseObservation'));
const ClinicalTasks = lazy(() => import('../../components/Patient/ClinicalTasks'));
const FluidChart = lazy(() => import('../../components/Patient/FluidChart'));

const Page = ({ location }) => {
	const item = useSelector(state => state.sidepanel.item);
	const patient = useSelector(state => state.sidepanel.patient);
	if (!item) return <Splash />;
	const isClosed = item?.status === 1;
	const hash = location.hash.substr(1).split('#');
	switch (hash[0]) {
		case 'nurse-observations':
			return <NurseObservation patient={patient} itemId={item.id} type="opd" can_request={!isClosed} />;
		case 'clinical-tasks':
			return <ClinicalTasks patient={patient} itemId={item.id} type="opd" can_request={!isClosed} />;
		case 'fluid-chart':
			return <FluidChart patient={patient} itemId={item.id} type="opd" readOnly={isClosed} />;
		default:
			return <NurseObservation patient={patient} itemId={item.id} type="opd" can_request={!isClosed} />;
	}
};

class OutPatientCareProfile extends Component {
	closeProfile = () => {
		storage.removeItem(SIDE_PANEL);
		this.props.toggleSidepanel(false);
	};

	componentDidMount() {
		const { location } = this.props;
		this.props.history.push(`${location.pathname}#nurse-observations`);
	}

	componentWillUnmount() {
		const { location } = this.props;
		this.props.history.push(`${location.pathname}#out-patient-care`);
	}

	render() {
		const { location, patient, item } = this.props;
		const isClosed = item?.status === 1;
		return (
			<div className="layout-w">
				<button aria-label="Close" className="close custom-close" type="button" onClick={this.closeProfile}>
					<span className="os-icon os-icon-close" />
				</button>
				<div className="content-w" style={{ width: 'calc(100% - 260px)', overflow: 'hidden' }}>
					<div className="content-i">
						<div className="content-box">
							<div className="row">
								<div className="col-sm-12">
									<ProfileBlock profile={true} patient={patient} hasButtons={false} canAdmit={false} canDischarge={false} opdItem={item} />
									<div className="d-flex justify-content-between align-items-center mb-2">
										<div>
											<span className={`badge badge-${isClosed ? 'success' : 'secondary'} mr-2`}>{isClosed ? 'Closed' : 'Open'}</span>
										</div>
									</div>
									<ul className="nav nav-tabs mt-3 mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
										<li className="nav-item">
											<a
												className={`nav-link ${location.hash.includes('nurse-observations') ? 'active' : ''}`}
												href={`${location.pathname}#nurse-observations`}
											>
												Observations
											</a>
										</li>
										<li className="nav-item">
											<a
												className={`nav-link ${location.hash.includes('clinical-tasks') ? 'active' : ''}`}
												href={`${location.pathname}#clinical-tasks`}
											>
												Tasks
											</a>
										</li>
										<li className="nav-item">
											<a
												className={`nav-link ${location.hash.includes('fluid-chart') ? 'active' : ''}`}
												href={`${location.pathname}#fluid-chart`}
											>
												Fluid Chart
											</a>
										</li>
									</ul>
								</div>
								<Suspense fallback={<Splash />}>
									<Switch>
										<HashRoute hash={location.hash} component={Page} />
									</Switch>
								</Suspense>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		patient: state.sidepanel.patient,
		item: state.sidepanel.item,
	};
};

export default withRouter(connect(mapStateToProps, { toggleSidepanel })(OutPatientCareProfile));
